import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

import permissionsUtil from "../../utils/permissions.util";

const PrivateRoute = ({
  component: Component,
  action,
  // subCategory,
  category,
  // user,
  /**
   * Use this props to pass custom objects to Components/Routes
   */
  componentProps,
  ...rest
}) => {
  const user = useSelector(state => state.user.value);
  const isLogin = !!user;

  const userHasAccess = permissionsUtil.checkAuth({
    action,
    category,
  });

  return (
    <Route
      {...rest}
      exact
      render={item => {
        const { location } = item;
        if (isLogin && userHasAccess) {
          const allProps = { ...item, componentProps };
          return <Component {...allProps} />;
        }

        if (isLogin && !userHasAccess) {
          return (
            <Redirect
              to={{
                pathname: "/forbidden",
                state: { from: location },
              }}
            />
          );
        }

        return (
          <Redirect
            to={{
              pathname: ROUTES.BASE.path,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  componentProps: PropTypes.object,
  action: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  subCategory: PropTypes.string,
  category: PropTypes.string,
};

export default PrivateRoute;
